import { FC, useContext, useEffect } from 'react';

import { CoveragesConsortiumSection } from '../CoverageConsortiumSection';

import { StepThreeFormContext } from '../../../StepThree/contexts/StepThreeForm';
import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';
import {
  GenericDataFormContext,
} from '../../../../../shared';

interface ConsortiumQuotationFormByTabProps {
  tabKey: number;
}

export const ConsortiumQuotationFormByTab: FC<
  ConsortiumQuotationFormByTabProps
> = ({ tabKey }) => {
  const { planOptionsBySelectedPlan, stepTwoForm } =
    useContext(StepTwoFormContext);
  const { stepThreeConsortiumQuotationForm } = useContext(StepThreeFormContext);
  const { canShowSpinner } = useContext(GenericDataFormContext);

  const planSelected = stepTwoForm?.getFieldValue(`plan-tab-${tabKey}`);

  const setPlanIfSelected = () => {
    if (planSelected) {
      stepThreeConsortiumQuotationForm.setFieldValue(
        `plan-tab-${tabKey}`,
        planSelected
      );
    }
  };

  useEffect(() => {
    setPlanIfSelected();
  }, [planSelected, stepThreeConsortiumQuotationForm, tabKey]);

  return (
    <>
      <ContentSection level='h3' title='Planes'>
        <RowSize>
          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: 'Lista de Planes:',
                name: `plan-tab-${tabKey}`,
              }}
              selectProps={{
                disabled: true,
                options: planOptionsBySelectedPlan,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>
      {!canShowSpinner ? <CoveragesConsortiumSection tabKey={tabKey} /> : <></>}
    </>
  );
};
